import { FC } from 'react';
import { Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { EmployeeNameCellViewModel } from './viewModel';

type EmployeeNameCellProps = GridRenderCellParams<EmployeeNameCellViewModel>;

export const EmployeeNameCell: FC<EmployeeNameCellProps> = ({ value: viewModel }) => {
  return <Typography>{viewModel?.cellValue}</Typography>;
};
